import Components from "views/Components/Components.jsx";
import HomePage from "views/HomePage/HomePage.jsx";
import ProfilePage from "views/ProfilePage/ProfilePage.jsx";
import LoginPage from "views/LoginPage/LoginPage.jsx";
import ClipPage from "views/ClipPage/ClipPage.jsx";

const Routes = [
  { path: "/profile-page", name: "ProfilePage", component: ProfilePage },
  { path: "/login-page", name: "LoginPage", component: LoginPage },
  { path: "/doc", name: "Components", component: Components },
  { path: "/search/:query", name: "HomePage", component: HomePage },
  { path: "/(replique|clip)/([a-zA-Z0-9-]+)_:id", name: "ClipPage", component: ClipPage },
  { path: "/(replique|clip)/:id", name: "ClipPage", component: ClipPage },
  { path: "/", name: "HomePage", component: HomePage },
  { path: "/:query", name: "HomePage", component: HomePage } // Default
];

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/routes.jsx